module.exports = __webpack_public_path__ + "img/en_backgroundImg000.b778f62b.jpg";